import React from "react";
import { useTitle } from "../../context/TitleContext";
import AddProduct from "../../components/Products/AddProduct";
import { useNavigate } from "react-router-dom";

const AddProductPage = () => {
  const { setTitle } = useTitle();
  const navigate = useNavigate();

  React.useEffect(() => {
    setTitle("إضافة منتج جديد");
  }, [setTitle]);

  const handleSuccess = () => {
    // إعادة توجيه إلى صفحة المنتجات بعد الإضافة بنجاح
    navigate("/products");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0">إضافة منتج جديد</h4>
            <button 
              className="btn btn-secondary"
              onClick={() => navigate("/products")}
            >
              <i className="bi bi-arrow-right me-2"></i>
              العودة للمنتجات
            </button>
          </div>
          <AddProduct onSuccess={handleSuccess} />
        </div>
      </div>
    </div>
  );
};

export default AddProductPage;
